<template>
  <NxInput
    name="nome"
    type="text"
    :label="label"
    placeholder="Digite o nome"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
export default {
  name: 'NxInputName',
  mixins: [useReactiveModelMixin('value')],
  props: {
    label: {
      type: String,
      default: 'Nome'
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val ? encodeURIComponent(val) : val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputName.vue